/* eslint-disable react/no-unknown-property, react/prop-types */
import { Figure, Text } from "@postenbring/hedwig-react";
import "../figure/figure.scss";
import "./embedded-video.scss";

export const EmbeddedVideo = ({ header, caption, video }) => {
  return (
    <>
      {header && (
        <Text variant="h1" className="hds-mb-24-32">
          {header}
        </Text>
      )}
      <Figure className="hds-mb-20-24">
        <div className="video-container">
          <iframe
            src={video.src}
            title=""
            frameborder="0"
            allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
        <figcaption>{caption}</figcaption>
      </Figure>
    </>
  );
};

EmbeddedVideo.displayName = "EmbeddedVideo";
